import React, { useMemo, useReducer, createContext, useEffect } from "react"
import Amplify, { Auth } from 'aws-amplify';
import { Link } from "gatsby"
import ResendVerification from "./../components/ResendVerification"
// Amplify Configuration

console.log("Configuring Amplify ...")

Amplify.configure({
  Auth: {
    mandatorySignIn: process.env.GATSBY_COGNITO_MANDATORY_SIGNIN,
    region: process.env.GATSBY_COGNITO_REGION,
    userPoolId: process.env.GATSBY_COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.GATSBY_COGNITO_CLIENT_ID

  }
})

// The Context

export const UserContext = createContext(null);

// Cognito Access
const registerErrorMsgs = (errorCode, username) => {
  if(errorCode === 'UsernameExistsException'){
    return (
      <>
      This email address is already in use. If you have not verified it please check your spam folder for the verification email or resend by clicking <ResendVerification locationData={username} ctaText={'here'} ctaType={'link'} />.
      If already verified click <Link to={`/register/#login`}>here</Link> to log in.
      </>
    );
  }

  if(errorCode === 'InvalidParameterException'){
    return (
      <>
      Please enter a valid phone number e.g. 07945123456
      </>
    );
  }

  if(errorCode === 'AuthError'){
    return (
      <>
      Invalid email or password.
      </>
    );
  }

  return (<></>);
}

const forgotPassErrorMsgs = (errorCode) => {
  if(errorCode === 'InvalidParameterException'){
    return (
      <>
      Please enter a valid email address. Enter the email you use to log in to EE PhoneSmart.
      </>
    );
  }

  if(errorCode === 'CodeMismatchException'){
    return (
      <>
      Sorry, this password reset link has expired and is not available anymore. If you still need to reset your password, please use the <Link to={`/account/forgot-password/`}>Forgotten password</Link> link when you try to log in.
      </>
    );
  }

  if(errorCode === 'ExpiredCodeException'){
    return (
      <>
      Sorry, this password reset link has expired and is not available anymore. If you still need to reset your password, please use the <Link to={`/account/forgot-password/`}>Forgotten password</Link> link when you try to log in.
      </>
    );
  }

  return (<></>);
}

const loginErrorMsgs = (errorCode) => {
  if(errorCode === 'AuthError'){
    return (
      <>
      Email cannot be empty.
      </>
    );
  }

  if(errorCode === 'InvalidParameterException' || errorCode === 'NotAuthorizedException'){
    return (
      <>
      Incorrect email or password.
      </>
    );
  }

  return (<></>);
}


const cognito_async = async (a, dispatch, cognito_user) => {
  if(a.action === "login") { // Login to an account
    try {
      const user = await Auth.signIn(a.data.email, a.data.password);
      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        console.log("Login success (new password): " + JSON.stringify(user.username))
        dispatch({action: "login_newpass", cognito_user: user})
      } else {
        console.log("Login success: " + JSON.stringify(user.username))
        const loggedinParentUser = await Auth.currentAuthenticatedUser();
        dispatch({action: "login_success", cognito_user: loggedinParentUser})
        let analytics_login= {
          event : "logIn_successfully",
          actionType: "CTA Click - Log in", 
          loginStatus: "logged-in",
          clickText: "Log in",
          linkType: "internal",
          linkUrl: window.location.href,
          pageName: "Grown up dashboard" ,
          moduleName: "Account overlay - engagement",
          userType: "parent"
        }
          window.dataLayer.push(analytics_login);
      }
    }
    catch (error) {
      console.log("Login error: " + JSON.stringify(error))
      console.log(error.code);
      let emsg = error.message;
      if(error.name === 'AuthError' || error.name === 'InvalidParameterException'
      || error.name === 'NotAuthorizedException'){
        emsg = loginErrorMsgs(error.name)
      }
      dispatch({action: "login_failure", code: error.code, reason: emsg})
      let analytics_login_failed= {
        event : "logIn_failed",
        actionType: "CTA Click - Log in", 
        loginStatus: "logged-out",
        clickText: "Log in",
        linkType: "internal",
        linkUrl: window.location.href,
        pageName: "parent register page" ,
        moduleName: "Register page - Engagement",
        userType: "anonymous"
      }
        window.dataLayer.push(analytics_login_failed);
    }
  } else if(a.action === "newpass") { // A password change has been made
    try {
      const user = await Auth.completeNewPassword(cognito_user,a.data.password)
      console.log("Login success: " + JSON.stringify(user.username))
      dispatch({action: "login_success", cognito_user: user})
    }
    catch (error) {
      console.log("New password error: " + JSON.stringify(error))
      dispatch({action: "login_failure", code: error.code, reason: error.message})
    }
  } else if(a.action === "register") { // Register for a new account
    console.log("Registering: "+JSON.stringify(a.data))
    try {
      const consentTime = new Date();
      const registeredUser = await Auth.signUp({
        username: a.data.email,
        password: a.data.password,
        attributes: {
          given_name: a.data.given_name,
          family_name: a.data.family_name,
          phone_number: a.data.phone_number,
          "custom:consent": JSON.stringify({
            progressNotifications: a.data.progressNotifications,
            btEEMarketing: {
            text: a.data.bytext,
            email: a.data.byemail
          },
          marketResearchConsent: a.data.marketResearchConsent,
          update: consentTime.toISOString()
          })
        }
      });
      console.log("Registered user: ", registeredUser.user);
      console.log("userConfirmedr: ", registeredUser.userConfirmed);
      dispatch({action: "register_success", username: registeredUser.user.username, userConfirmed: registeredUser.userConfirmed})
    }
    catch (error) {
      console.log("Register error: " + JSON.stringify(error));
      let emsg = error.message;
      if(error.code === 'UsernameExistsException'){
        let code = error.code;
        emsg = registerErrorMsgs(error.code, a.data.email)
      }

      if(error.code === 'InvalidParameterException' && emsg === 'Invalid phone number format.'){
        let code = error.code;
        emsg = registerErrorMsgs(error.code, null)
      }

      if(error.name === 'AuthError'){
        emsg = registerErrorMsgs(error.name, null)
      }

      dispatch({action: "register_failure", code: error.code, reason: emsg})
    }
  } else if(a.action === "resendsignup") { // resend verification email
    try {
      await Auth.resendSignUp(a.data.username)
      console.log("Resend Verification email success!")
      dispatch({action: "resendsignup_response", code: "RESENDSIGNUP_SUCCESS", reason: "Success!"})
    }
    catch (error) {
      console.log("Resend Verification email error: " + JSON.stringify(error))
      dispatch({action: "resendsignup_response", code: error.code, reason: error.message})
    }
  }else if(a.action === "verify") { // Verify a new account
    try {
      await Auth.confirmSignUp(a.data.email,a.data.code)
      console.log("Verify success!")
      dispatch({action: "verify_response", code: "VERIFY_SUCCESS", reason: "Success!"})
    }
    catch (error) {
      console.log("Verify error: " + JSON.stringify(error))
      dispatch({action: "verify_response", code: error.code, reason: error.message})
    }
  } else if(a.action === "forgot") { // Request to reset a lost password
    try {
      await Auth.forgotPassword(a.data.email)
      console.log("Forgot password success!")
      dispatch({action: "forgot_response", code: "FORGOT_SUCCESS", reason: "Success!"})
    }
    catch (error) {
      console.log("Forgot password error: " + JSON.stringify(error))
      let emsg = error.message;
      if(error.code === 'InvalidParameterException'){
        let code = error.code;
        emsg = forgotPassErrorMsgs(error.code)
      }
      dispatch({action: "forgot_response", code: error.code, reason: emsg})
    }
  } else if(a.action === "forgotreset") { // Reset a lost password
    try {
      await Auth.forgotPasswordSubmit(a.data.email,a.data.code,a.data.password)
      console.log("Forgot password reset success!")
      dispatch({action: "forgotreset_response", code: "FORGOTRESET_SUCCESS", reason: "FORGOTRESET_SUCCESS"})
    }
    catch (error) {
      console.log("Forgot password reset error: " + JSON.stringify(error))
      let emsg = error.message;
      if(error.code === 'CodeMismatchException' || error.code === 'ExpiredCodeException'){
        let code = error.code;
        emsg = forgotPassErrorMsgs(error.code)
      }
      dispatch({action: "forgotreset_response", code: error.code, reason: emsg})
    }
  } else if(a.action === "updateattributes") { // Log out
    try {
      const loggedinParentUser = await Auth.currentAuthenticatedUser();
      const attributeName = a?.data?.parentUserAttName;
      const attributeValue = a?.data?.parentUserAttValue;
      var updateObj = {};
      updateObj[attributeName] = attributeValue;

      await Auth.updateUserAttributes(loggedinParentUser, updateObj);
      const updatedParentUser = await Auth.currentAuthenticatedUser();

      dispatch({action: "updateattributes_response", code: 'UPDATE_SUCCESS', reason: "UPDATE_SUCCESS", cognito_user: updatedParentUser})
    }
    catch (error) {
      console.log("Updated user attributes: " + JSON.stringify(error))
      dispatch({action: "updateattributes_response", code: error.code, reason: error.message})
    }
  } else if(a.action === "changepass") { // changepass
    try {
      const updatedParentUser = await Auth.currentAuthenticatedUser();
      console.log("Updated user changepass, successfully!", updatedParentUser);
      dispatch({action: "changepass_response", code: 'UPDATE_SUCCESS', reason: "UPDATE_SUCCESS", cognito_user: updatedParentUser})
    }
    catch (error) {
      console.log("Updated user changepass: " + JSON.stringify(error))
      dispatch({action: "changepass_response", code: error.code, reason: error.message})
    }
  } else if(a.action === "logout") { // Log out
      try {
        await Auth.SignOut()
        console.log("Sign out success!")
        dispatch({action: "signedout"})
      }
      catch (error) {
        console.log("Sign out error: " + JSON.stringify(error))
        dispatch({action: "signedout"})
      }
  }
}

// Reducer

/*
From auth forms:
  action (*)
    .action
    .data
  source

From cognito:
  action
  code
  reason
  cognito_user

To auth forms:
  status (*)
  target
  code
  message
  cognito_user
*/

const userReducer = (state, a) => {

  const newState={...state}

  const cognito_requests = {
    login:1,
    newpass:1,
    register:1,
    verify:1,
    forgot:1,
    forgotreset:1,
    logout:1,
    resendsignup:1,
    updateattributes:1,
    changepass:1
  }

  const cognito_responses = {
    login_success:1,
    login_newpass:1,
    login_failure:1,
    register_success:1,
    register_failure:1,
    verify_response:1,
    forgot_response:1,
    forgotreset_response:1,
    resendsignup_response:1,
    updateattributes_response:1,
    changepass_response:1
  }

  // Requests from Auth Components to Congito
  if(a.action in cognito_requests) {
     console.log("Found cognito request: ")
    newState.action=a
    newState.target=a.source ? a.source : ""

  // Responses from Cognito to Auth Components
  } else if(a.action in cognito_responses) {
     console.log("Found cognito response: ")
    newState.status = a.action
    newState.code = a.code ? a.code : ""
    newState.message = a.reason ? a.reason : ""
    if(a.username) { newState.username=a.username }
    if(a.cognito_user) { newState.cognito_user=a.cognito_user }

  // Signed Out
  } else if(a.action === "signedout") {
    console.log("User signed out")
    newState.cognito_user=null;
  // Clear Messaging
  } else if(a.action === "clear") {
    console.log("Clearing action & status")
    newState.action=null;
    newState.status=null;
    newState.code=null;

  } else {
    console.log("Unknown userReducer action: " + JSON.stringify(a.action))
    return state;
  }
  return newState
}

// Main component

const UserManagement = ({ children }) => {
  const getInitialState = () => {
    console.log('getInitialState');
    let initialState = {
      cognito_user: null,
      username: "",
      status: "",
      target: "",
      code: "",
      message: ""
    }

    try {
      const cognito_user = (typeof window !== "undefined") && window.localStorage.getItem("cognito_user")
      initialState.cognito_user = cognito_user ? JSON.parse(cognito_user) : null
      return(initialState)
    }
    catch(e) {
      return(initialState)
    }
  }
  const [userState, dispatch] = useReducer(userReducer, getInitialState());
  const value = useMemo(() => [userState, dispatch], [userState]);

  useEffect(() => {
    console.log('localStorage update', userState);
    if(userState) {
      console.log('localStorage updated =>', userState);
      window.localStorage.removeItem("cognito_user")
      window.localStorage.setItem("cognito_user", JSON.stringify(userState?.cognito_user));
      window.localStorage.setItem("cognito_id_token",userState?.cognito_user?.signInUserSession?.idToken?.jwtToken)
    } else {
      window.localStorage.removeItem("cognito_user")
      window.localStorage.removeItem("cognito_id_token")
    }
  }, [userState])

  useEffect(() => {
    if(userState.action) {
      console.log('Cognito Async');
      const action=userState.action
      dispatch({action: "clear"})
      cognito_async(action, dispatch, userState.cognito_user)
    }
  })

  return(
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  )
}

export default UserManagement
